import { lazy, Suspense, useState, useEffect } from "react";
import Loading from "../../components/comComponents/Loading";
import Header from "../../components/header/Header";
import { autoHypenBiz, osType, removeS, cookieValue } from "../../modules/Common";
import { callOpenApiNonAuth } from "../../modules/TokenBase";
import { ErrorModule } from "../../modules/ErrorModule";
import GeneralClientBtmSheet from "../../components/doc/GeneralClientBtmSheet";
import IbkLoanClientBtmSheet from "../../components/doc/IbkLoanClientBtmSheet";
import { useHistory } from "react-router-dom";

const Index = () =>{
    const navigate = useHistory();
    const [inputBizNum, setInputBizNum] = useState(''); //사업자번호 입력 값
    const [genClientbtmSheet, setGenClientbtmSheet] = useState(false); //일반고객 바텀시트 오픈 여부
    const [ibkLoanClientbtmSheet, setIbkLoanClientbtmSheet] = useState(false); //IBK여신 바텀시트 오픈 여부
    const [ibkLoanBizNm, setIbkLoanBizNm] = useState('') //IBK여신 사업장명
    const [btnOn, setBtnOn] = useState(false); //버튼 활성화 여부
    const [alertContents, setAlertContents] = useState(''); //알림 내용
    const [alertIcon, setAlertIcon] = useState(''); //알림 아이콘
    const [alertOpen, setAlertOpen] = useState(false); //알림 오픈 여부
    const [alertTagInsert, setAlertTagInsert] =  useState(false); //알림 문자열 html로 주입
    const [noticContents, setNoticContents] = useState('')// 공지 내용
    const [noticeOpen, setNoticeOpen] = useState(false); //공지 오픈 여부
    const [loadOpen, setLoadOpen] = useState(false); //로딩 여부

    const OneBtnAlert = lazy(()=> import('../../components/comComponents/OneBtnAlert'));
    const NoticeAlert = lazy(()=> import('../../components/comComponents/NoticeAlert'));
    
    const onBizNum = (e) => {
        e.target.value = autoHypenBiz(e.target.value);
        if(e.target.value.length >= 12){
            e.target.value = e.target.value.substr(0,12);
            setBtnOn(true)
        }else{
            setBtnOn(false)
        }
        setInputBizNum(e.target.value);
    }

    const handleKeyAction = e =>{
        if(e.key === "Enter"){
        	chkNext();
        }
    }

    const chkNext = () =>{
        if(btnOn){
            setBtnOn(false);
            setLoadOpen(true);

            //25.02.18 진입 제어 하기
            const param = {}
            callOpenApiNonAuth("/api/cm/v1/cms000/docChnlEnryAbynInq", param, function( result ){
                if(result.STATUS == "0000"){
                    var data = result.RSLT_DATA;
                    if(data.chnlEnryAbyn == "N"){
                        setLoadOpen(false);
                        setAlertTagInsert(true);
                        setAlertIcon("F");
                        setAlertContents(data.lmtnRsn);
                        alertFun(true);
                        setBtnOn(true);
                    }else{
                        chkBizNum()
                    }
                }else{
                    chkBizNum()
                }
            },function (e) {
                chkBizNum()
            });
        }
    }
    //IBK 여신고객 여부 체크
    const chkBizNum = () =>{
        const param = {
            "bzn" : removeS(inputBizNum)
        }
        callOpenApiNonAuth("/api/cm/v1/cms010/lbscInq", param, function( result ){
            setLoadOpen(false);
            if(result.STATUS == "0000"){
                var data = result.RSLT_DATA;
                if(data.lbscYn == "Y"){ //IBK 여신고객일 경우
                    setIbkLoanBizNm(data.bsunNm);
                    setIbkLoanClientbtmSheet(true);
                    sessionStorage.setItem('docBizNo', removeS(inputBizNum));
                    sessionStorage.setItem('docBizNm', data.bsunNm);
                    sessionStorage.setItem('docSbmsReqYn', data.docSbmsReqYn);
                }else{
                    setGenClientbtmSheet(true);
                }
                setBtnOn(true);
            }else{
                setBtnOn(true);
                setAlertIcon("F");
                setAlertContents(result.RSLT_MSG)
                alertFun(true);
            }
        },function (e) {
            setLoadOpen(false);
            let param = ErrorModule(e);
            if(param) {
                setBtnOn(true);
                setAlertIcon("F");
                setAlertContents("["+e.responseJSON.msgCd+"]"+e.responseJSON.mnmsgCntn);
                alertFun(true);
            }
        });

    }
    //중복 스크래핑 체크
    const chkDuplication = () => {
        if(sessionStorage.getItem('docSbmsReqYn') === "Y"){
            navigate.push('/doc/completion');
        }else{
            chkCloudCert();
        }
    }
    //클라우드 인증서 등록여부 체크
    const chkCloudCert = () =>{
        setLoadOpen(true);
        const param = {
            "bzn" : removeS(inputBizNum)
        }
        callOpenApiNonAuth("/api/cm/v1/cms010/atshInfoInq", param, function( result ){
            if(result.STATUS == "0000"){
                setLoadOpen(false);
                var data = result.RSLT_DATA;
                if(data.atshRgsnYn == "N"){ //클라우드 인증서 등록 여부 체크(N)
                    if(osType() === "mobile"){ // [CM5000-04] 공동인증서 등록 안내 화면으로 이동
                        navigate.push('/doc/cert');
                    }else{
                        //[CM5000-5]서류 제출 리스트 화면으로 이동
                        navigate.push('/doc/scrap');
                    }
                }else{//클라우드 인증서 등록 여부 체크(Y)
                    //[CM5000-5]서류 제출 리스트 화면으로 이동
                    navigate.push('/doc/scrap');
                }
            }else{
                setLoadOpen(false);
                setAlertIcon("F");
                setAlertContents(result.RSLT_MSG)
                alertFun(true);
            }
        },function (e) {
            setLoadOpen(false);
            let param = ErrorModule(e);
            if(param) {
                setAlertIcon("F");
                setAlertContents("["+e.responseJSON.msgCd+"]"+e.responseJSON.mnmsgCntn);
                alertFun(true);
            }
        });
    }

    //알림 오픈 함수
    const alertFun = (open) => {
        setAlertOpen(open);
        
        if(!open){
            if(alertTagInsert){
                setAlertTagInsert(false);
            }
        }
    }

    // 대고객 안내 
    const noticAlert = () =>{
        setLoadOpen(true);
        const param = {}
        callOpenApiNonAuth("/api/cm/v1/cms000/docChnlEnryAbynInq", param, function( result ){
            setLoadOpen(false);
            if(result.STATUS == "0000"){
                var data = result.RSLT_DATA;
                if(data.chnlEnryAbynInfo == "N"){
                    if(cookieValue("dc_doc") != "Y"){
                        setNoticContents(data.lmtnRsnInfo);
                        noticeFun(true);
                    }
                }
            }
        },function (e) {
            setLoadOpen(false);
        });
    }

    const noticeFun = (open) => {
        setNoticeOpen(open);
    }

    useEffect(()=>{
        noticAlert();
        sessionStorage.clear();
    },[])

    return(
        <div>
            <Header headerTitle="서류제출" arrowYn={false} closeYn={false}/> 
            <div id="container">		
                <div className="content">
                    <div className="wrapBoxPd bottomGnbShow">
                        <div className="formbox">
                            <p className="tit">사업자번호를 입력해 주세요</p>
                            <div className="valChk">
                                <div className="inpbox">
                                    <input type="text" inputMode="numeric" className="txtBold" placeholder="숫자만 입력해 주세요." value={inputBizNum} onChange={onBizNum} onKeyUp={handleKeyAction}/>
                                </div>
                                <span className="infoTxt"></span>
                            </div>
                        </div>

                        <div className="mt40">
                            <div className="ibkbankLogo newLogo"></div>
                            <div className="textImgWrap">
                                <div className="textImg ibkBoxLogo"></div>
                                <div className="txt">를 통해 <span className="txtBlue">기업은행으로 서류 제출</span></div>
                            </div>
                            <div className="mediumTit lSpacing06 mt8">영업점에서 서류 제출을 요청받으신 경우 영업점 재방문 없이 간편하게 서류를 제출해 보세요.</div>
                            <div className="ImgWrap">
                                <div className="img CM5000-1"></div>
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div className="fullbtn">
                    <a onClick={()=>{chkNext()}} className={`btn ${btnOn ? 'on' : ''}`}>확인</a>
                </div>

            </div>
            <Suspense fallback={<></>}>
                {alertOpen ? <OneBtnAlert alertContents={alertContents} alertOpen={alertOpen} alertFun={alertFun} alertIcon={alertIcon} alertTagInsert={alertTagInsert}/> : <></>}
                {genClientbtmSheet ? <GeneralClientBtmSheet genClientbtmSheet={genClientbtmSheet} setGenClientbtmSheet={setGenClientbtmSheet}/> : <></>}
                {ibkLoanClientbtmSheet ? <IbkLoanClientBtmSheet ibkLoanClientbtmSheet={ibkLoanClientbtmSheet} setIbkLoanClientbtmSheet={setIbkLoanClientbtmSheet} ibkLoanBizNm = {ibkLoanBizNm} chkDuplication={chkDuplication}/> : <></>}
                {noticeOpen ? <NoticeAlert noticContents={noticContents} noticeOpen={noticeOpen} noticeFun={noticeFun}/> : <></>}
            </Suspense>
            <Loading loadOpen={loadOpen}/>
        </div>
    )
}
export default Index;